export default [
  {
    value: 10,
    key: 10,
    label: '巨量引擎'
  },
  {
    value: 16,
    key: 16,
    label: '腾讯'
  },
  {
    value: 32,
    key: 32,
    label: '磁力引擎'
  },
  {
    value: 45,
    key: 45,
    label: '百度信息流'
  },
  {
    value: 6,
    key: 6,
    label: '超级汇川'
  }
]
